const SECTIONS = [
    {
        title: "1. Quais dados coletamos",
        items: [
            "Newsletter: apenas o seu endereço de e-mail, fornecido voluntariamente no formulário de inscrição.",
            "Formulário de contato: nome, e-mail e o conteúdo da mensagem enviada.",
            "Navegação: dados anonimizados de uso (páginas visitadas, tempo de leitura) para melhorar o conteúdo.",
            "Cookies de publicidade: o Google AdSense pode utilizar cookies para exibir anúncios relevantes.",
        ],
    },
    {
        title: "2. Como usamos esses dados",
        items: [
            "Enviar a newsletter semanal que você solicitou — e apenas ela.",
            "Responder às mensagens enviadas pelo formulário de contato.",
            "Entender quais temas interessam aos leitores e planejar novos artigos.",
            "Exibir publicidade que financia o conteúdo gratuito do site.",
        ],
    },
    {
        title: "3. Cookies e publicidade do Google",
        items: [
            "O Google, como fornecedor terceiro, utiliza cookies para veicular anúncios neste site.",
            "Com o cookie DART, o Google pode exibir anúncios com base nas suas visitas a este e a outros sites.",
            "Você pode desativar a publicidade personalizada em adssettings.google.com.",
            "Também é possível gerenciar cookies de terceiros em aboutads.info/choices.",
        ],
    },
    {
        title: "4. O que nunca fazemos",
        items: [
            "Nunca vendemos, alugamos ou compartilhamos seu e-mail com terceiros para marketing.",
            "Nunca enviamos spam ou mensagens que você não solicitou.",
            "Nunca coletamos dados financeiros, senhas ou documentos dos leitores.",
        ],
    },
    {
        title: "5. Seus direitos (LGPD — Lei 13.709/2018)",
        items: [
            "Confirmar a existência e acessar os dados que temos sobre você.",
            "Corrigir dados incompletos, inexatos ou desatualizados.",
            "Solicitar a exclusão dos seus dados a qualquer momento.",
            "Revogar o consentimento e cancelar a newsletter com um clique ou um e-mail.",
        ],
    },
    {
        title: "6. Como exercer seus direitos",
        items: [
            "Escreva para contato@investidorcomum.com.br com o assunto 'Privacidade'.",
            "Respondemos a solicitações de dados em até 15 dias, conforme a LGPD.",
            "Esta política pode ser atualizada; a data da última revisão aparece abaixo.",
        ],
    },
];

export default function Privacidade() {
    return (
        <main data-testid="privacidade-page" className="pt-28 md:pt-36 pb-20">
            <div className="max-w-3xl mx-auto px-4 md:px-0">
                <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Documento legal</span>
                <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-4">Política de Privacidade</h1>
                <p className="mt-4 text-sm text-slate-500">Última atualização: 7 de agosto de 2026 · Investidor Comum (investidorcomum.com.br)</p>

                <p className="mt-8 text-base md:text-lg text-slate-300 leading-[1.85]">
                    Levamos sua privacidade tão a sério quanto levamos finanças. Esta política explica,
                    em linguagem clara, o que coletamos, por que coletamos e quais são os seus direitos —
                    em conformidade com a Lei Geral de Proteção de Dados (LGPD).
                </p>

                <div className="mt-12 flex flex-col gap-10">
                    {SECTIONS.map((s, i) => (
                        <section key={s.title} data-testid={`privacidade-section-${i}`}>
                            <h2 className="font-serif text-2xl tracking-tight mb-4 flex items-start gap-3">
                                <span className="w-1 h-7 bg-gold shrink-0 mt-0.5" />
                                {s.title}
                            </h2>
                            <ul className="flex flex-col gap-2.5 ml-4">
                                {s.items.map((item, j) => (
                                    <li key={j} className="flex items-start gap-3 text-sm md:text-base text-slate-400 leading-relaxed">
                                        <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0 mt-2" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </section>
                    ))}
                </div>
            </div>
        </main>
    );
}
